(function(){
  var routes = window.routes || {cartAdd:"/cart/add.js",cart:"/cart.js"};
  function money(c){ return "£" + (c/100).toFixed(2); }
  function openCart(){ var d=document.getElementById('drawer'),s=document.getElementById('scrim'); if(d)d.classList.add('on'); if(s)s.classList.add('on'); refresh(); }
  function closeCart(){ var d=document.getElementById('drawer'),s=document.getElementById('scrim'); if(d)d.classList.remove('on'); if(s)s.classList.remove('on'); }
  function setCount(n){ document.querySelectorAll('[data-cart-count]').forEach(function(b){ b.textContent=n; b.style.display=n?'grid':'none'; }); }
  function render(cart){
    setCount(cart.item_count);
    var box=document.getElementById('citems'); var tot=document.getElementById('ctotal');
    if(tot) tot.textContent=money(cart.total_price);
    if(!box) return;
    if(!cart.items.length){ box.innerHTML='<div class="empty">Your basket is empty.<br>Add some loot! 💥</div>'; return; }
    box.innerHTML=cart.items.map(function(i){
      return '<div class="ci"><img src="'+(i.image? i.image.replace(/(\.[a-z]+)(\?|$)/,'_120x$1$2'):'')+'" alt="">'+
        '<div class="ciname"><b>'+i.product_title+'</b><div class="price">'+i.quantity+' × '+money(i.price)+'</div>'+
        (i.variant_title? '<small style="font-weight:800;color:var(--muted)">'+i.variant_title+'</small>':'')+'</div></div>';
    }).join('');
  }
  function refresh(){ fetch(routes.cart).then(function(r){return r.json();}).then(render).catch(function(){}); }
  function add(id,qty){
    return fetch(routes.cartAdd,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:qty||1})})
      .then(function(r){return r.json();}).then(function(){ openCart(); });
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-add-id]');
    if(b){ e.preventDefault(); b.disabled=true; add(b.getAttribute('data-add-id'),1).finally(function(){b.disabled=false;}); }
  });
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(f.id==='product-form'){
      e.preventDefault();
      var fd=new FormData(f);
      var id=fd.get('id'); if(!id){ var sel=f.querySelector('select[name=id]'); id=sel?sel.value:null; }
      add(id, fd.get('quantity')||1);
    }
  });
  // size radios -> set variant id by matching option values
  document.addEventListener('change',function(e){
    if(e.target.matches('.size input')){
      e.target.closest('.sizes').querySelectorAll('.size').forEach(function(l){l.classList.remove('on');});
      e.target.closest('.size').classList.add('on');
    }
  });
  window.TG={openCart:openCart,closeCart:closeCart,refresh:refresh,add:add};
  refresh();
})();
